import { UserServiceContext } from "@twii/ozone/lib/user/service/UserServiceContext";
import { MockUserService } from "@twii/ozone/lib/user/service/MockUserService";
import { UserDataServiceContext } from "@twii/ozone/lib/user/service/UserDataServiceContext";
import { MockUserDataService } from "@twii/ozone/lib/user/service/MockUserDataService";
import { ListingServiceContext } from "@twii/ozone/lib/listing/service/ListingServiceContext";
import { MockListingService } from "@twii/ozone/lib/listing/service/MockListingService";
import { ImageServiceContext } from "@twii/ozone/lib/media/service/ImageServiceContext";
import { MockImageService } from "@twii/ozone/lib/media/service/MockImageService";
import { StorageServiceContext } from "@twii/bored/lib/service/StorageServiceContext";

const mock = (env : any) => {
    console.log("-- Applying Mock Configuration");
    UserServiceContext.value = new MockUserService();
    UserDataServiceContext.value = new MockUserDataService();
    ListingServiceContext.value = new MockListingService();
    ImageServiceContext.value = new MockImageService();
};

export { mock, mock as default }